import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, ListSubheader } from '@mui/material';
import PropTypes from 'prop-types';
import { getRouteVariantCode } from '../../../../utils/helpers';
import { TRIP_DIRECTION_INBOUND, TRIP_DIRECTION_OUTBOUND, getDirectionDisplayLabel } from '../../../../types/vehicle-types';

const RouteVariantSelect = ({ label, disabled, routeVariants, selectedRouteVariant, onSelectVariant }) => {
    // Group variants by routeShortName
    const groupedByRoute = routeVariants.filter(v => v.hidden !== true).reduce((acc, variant) => {
        const { routeShortName } = variant;
        if (!acc[routeShortName]) {
            acc[routeShortName] = [];
        }
        acc[routeShortName].push(variant);
        return acc;
    }, {});

    return (
        <FormControl className="w-100 position-relative">
            <InputLabel id="grouped-native-select-label">
                { label }
            </InputLabel>
            <Select
                labelId="grouped-native-select-label"
                id="grouped-native-select"
                disabled={ disabled }
                label={ label }
                value={ selectedRouteVariant?.routeVariantId || '' } // Controlled value
                onChange={ (event) => {
                    const selectedId = event.target.value;
                    const selectedVariant = routeVariants.find(
                        variant => variant.routeVariantId === selectedId,
                    );
                    onSelectVariant(selectedVariant); // Pass the full variant object to the parent
                } }
            >
                {Object.entries(groupedByRoute).map(([routeShortName, variants]) => {
                    // Group variants by directionId within each route
                    const inboundVariants = variants.filter(variant => variant.directionId === TRIP_DIRECTION_INBOUND);
                    const outboundVariants = variants.filter(variant => variant.directionId === TRIP_DIRECTION_OUTBOUND);

                    return [
                        // Inbound group
                        inboundVariants.length > 0 && (
                            <ListSubheader key={ `${routeShortName}-inbound` }>
                                {`Route ${routeShortName} ${getDirectionDisplayLabel(TRIP_DIRECTION_INBOUND)}`}
                            </ListSubheader>
                        ),
                        ...inboundVariants.map(variant => (
                            <MenuItem
                                key={ variant.routeVariantId }
                                value={ variant.routeVariantId }
                                disabled={ variant.hasTripModifications === true }
                            >
                                {`${getRouteVariantCode(variant)} - ${variant.routeLongName}`}
                            </MenuItem>
                        )),

                        // Outbound group
                        outboundVariants.length > 0 && (
                            <ListSubheader key={ `${routeShortName}-outbound` }>
                                {`Route ${routeShortName} ${getDirectionDisplayLabel(TRIP_DIRECTION_OUTBOUND)}`}
                            </ListSubheader>
                        ),
                        ...outboundVariants.map(variant => (
                            <MenuItem
                                key={ variant.routeVariantId }
                                value={ variant.routeVariantId }
                                disabled={ variant.hasTripModifications === true }
                            >
                                {`${getRouteVariantCode(variant)} - ${variant.routeLongName}`}
                            </MenuItem>
                        )),
                    ];
                })}
            </Select>
        </FormControl>
    );
};

RouteVariantSelect.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    routeVariants: PropTypes.array,
    selectedRouteVariant: PropTypes.object,
    onSelectVariant: PropTypes.func.isRequired,
};

RouteVariantSelect.defaultProps = {
    label: 'Select a route variant',
    disabled: false,
    routeVariants: [],
    selectedRouteVariant: {
        shapeWkt: '',
    },
};

export default RouteVariantSelect;
